// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"484aca94","172":"1f80c6b4","452":"f24a05e0","773":"b28e80f8","962":"b2b421bb"}[chunkId] + ".chunk.js";
};